import { autoCapitalize } from '@/utils/autoCapitalize'
import { ResendDocumentsData } from './ResendDocumentsMapper.types'

class ResendDocumentsMapper {
  toDomain(persistenceData: ResendDocumentsData) {
    return {
      documentsQuantity: persistenceData?.quantidadeDocumentos,
      patientName: autoCapitalize(persistenceData?.nomePaciente),
    }
  }
}

export default new ResendDocumentsMapper()
